import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import detectLanguage from './languageDetector';

import en from '../locales/en.json';
import sr from '../locales/sr.json';

// Custom language detector plugin
const customDetector = {
  name: 'customDetector',
  lookup() {
    return detectLanguage();
  },
  cacheUserLanguage() {
    // Optionally cache the language in localStorage
    // For now, we'll skip caching to always use fresh detection
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      sr: {
        translation: sr
      }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'sr'],
    detection: {
      order: ['customDetector'],
      caches: [] // Disable caching for now
    },
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false // Disable suspense for widget compatibility
    }
  });

export default i18n;
